module.exports = __webpack_public_path__ + "static/media/1_screen.7db7989d.png";